import { LineChart } from "@mui/x-charts";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChartColorSwitch from "../../Common/ChartColorSwitch";
import { Loader } from "../../Common/Loader";
import { getReportCallDuration } from "../../Redux/Slice/Report/Customer/GetReportCallDurationSice";
import { getReportCountMetrics } from "../../Redux/Slice/Report/Customer/GetReportCountMetricsSlice";
import { getReportDayWiseCalls } from "../../Redux/Slice/Report/Customer/GetReportDayWiseCallsSlice";
import { getReportHourlyCalls } from "../../Redux/Slice/Report/Customer/GetReportHourlyCallsSlice";
import CallDialIcon from "../../Assets/svgs/Reports/CallDialIcon";
import AnsweredIcon from "../../Assets/svgs/Reports/AnsweredIcon";
import NoAnswerIcon from "../../Assets/svgs/Reports/NoAnswerIcon";
import VoiceMailIcon from "../../Assets/svgs/Reports/VoiceMailIcon";
import InvalidCallIcon from "../../Assets/svgs/Reports/InvalidCallIcon";
import AnsweredDurationIcon from "../../Assets/svgs/Reports/AnsweredDurationIcon";

export const Reports = () => {
  const dispatch = useDispatch();
  const { reportCountMetricsData, loading: isLoadingReportCountMetricsData } =
    useSelector((s) => s?.reportCountMetrics);
  const { reportDayWiseCallsData, loading: isLoadingReportDayWiseCallsData } =
    useSelector((s) => s?.reportDayWiseCalls);
  const { reportHourlyCallsData, loading: isLoadingReportHourlyCallsData } =
    useSelector((s) => s?.reportHourlyCalls);
  const { reportCallDurationData, loading: isLoadingReportCallDurationData } =
    useSelector((s) => s?.reportCallDuration);

  const reportDayWiseCallsDataChartLabelData =
    reportDayWiseCallsData &&
    reportDayWiseCallsData?.data &&
    Array.isArray(reportDayWiseCallsData?.data)
      ? reportDayWiseCallsData?.data?.map((metrics) => metrics?.label)
      : [];

  const reportDayWiseCallsDataChartData =
    reportDayWiseCallsData &&
    reportDayWiseCallsData?.data &&
    Array.isArray(reportDayWiseCallsData?.data)
      ? reportDayWiseCallsData?.data?.map((metrics) => metrics?.value)
      : [];

  const reportHourlyCallsChartLabelData =
    reportHourlyCallsData &&
    reportHourlyCallsData?.data &&
    Array.isArray(reportHourlyCallsData?.data)
      ? reportHourlyCallsData?.data?.map((metrics) => metrics?.label)
      : [];

  const reportHourlyCallsChartData =
    reportHourlyCallsData &&
    reportHourlyCallsData?.data &&
    Array.isArray(reportHourlyCallsData?.data)
      ? reportHourlyCallsData?.data?.map((metrics) => metrics?.value)
      : [];

  const reportCallDurationChartLabelData =
    reportCallDurationData &&
    reportCallDurationData?.data &&
    Array.isArray(reportCallDurationData?.data)
      ? reportCallDurationData?.data?.map((metrics) => metrics?.month)
      : [];

  const reportCallDurationChartData =
    reportCallDurationData &&
    reportCallDurationData?.data &&
    Array.isArray(reportCallDurationData?.data)
      ? reportCallDurationData?.data?.map((metrics) => metrics?.totalDuration)
      : [];

  useEffect(() => {
    dispatch(getReportCallDuration());
    dispatch(getReportCountMetrics());
    dispatch(getReportDayWiseCalls());
    dispatch(getReportHourlyCalls());
  }, []);

  const hasChartDataValue = (data = []) => {
    const isVal = data.some((i) => i >= 1);
    return isVal;
  };

  return (
    <div className="page__body">
      {isLoadingReportCountMetricsData ||
      isLoadingReportDayWiseCallsData ||
      isLoadingReportHourlyCallsData ||
      isLoadingReportCallDurationData ? (
        <Loader />
      ) : null}
      <div className="dashboardWrap">
        <div className="dashboardWrap__head">
          <div className="dashboardWrap__head__item">
            <div className="card">
              <div className="icon">
                <CallDialIcon />
              </div>
              <div className="info">
                <h3 className="title">Total Dials</h3>
                <h4 className="value">
                  {reportCountMetricsData?.data?.totalDials ?? 0}
                </h4>
              </div>
            </div>
          </div>
          <div className="dashboardWrap__head__item">
            <div className="card">
              <div className="icon">
                <AnsweredIcon />
              </div>
              <div className="info">
                <h3 className="title">Total Answered</h3>
                <h4 className="value">
                  {reportCountMetricsData?.data?.totalAnswered ?? 0}
                </h4>
              </div>
            </div>
          </div>
          <div className="dashboardWrap__head__item">
            <div className="card">
              <div className="icon">
                <NoAnswerIcon />
              </div>
              <div className="info">
                <h3 className="title">No Answers</h3>
                <h4 className="value">
                  {reportCountMetricsData?.data?.totalNoAnswer ?? 0}
                </h4>
              </div>
            </div>
          </div>
          <div className="dashboardWrap__head__item">
            <div className="card">
              <div className="icon">
                <VoiceMailIcon />
              </div>
              <div className="info">
                <h3 className="title">Voice Mail</h3>
                <h4 className="value">
                  {reportCountMetricsData?.data?.totalVoicemail ?? 0}
                </h4>
              </div>
            </div>
          </div>
          <div className="dashboardWrap__head__item">
            <div className="card">
              <div className="icon">
                <InvalidCallIcon />
              </div>
              <div className="info">
                <h3 className="title">Invalid</h3>
                <h4 className="value">
                  {reportCountMetricsData?.data?.totalInvalid ?? 0}
                </h4>
              </div>
            </div>
          </div>
          <div className="dashboardWrap__head__item">
            <div className="card">
              <div className="icon">
                <AnsweredDurationIcon />
              </div>
              <div className="info">
                <h3 className="title">Answered Duration (Min)</h3>
                <h4 className="value">
                  {reportCountMetricsData?.data?.totalAnsweredDuration ?? 0}
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="dashboardWrap__body">
          <div className="cardRow cardRow__2">
            <div className="col">
              <div className="card">
                <div className="card__header">
                  <h3 className="title">Day Wise Calls</h3>
                </div>
                <div className="card__body">
                  <LineChart
                    height={300}
                    colors={["#8b58f1"]}
                    series={[{ data: reportDayWiseCallsDataChartData }]}
                    xAxis={[
                      {
                        scaleType: "point",
                        data: reportDayWiseCallsDataChartLabelData,
                        label: "Day of the week",
                      },
                    ]}
                    yAxis={[
                      {
                        tickMinStep: hasChartDataValue(
                          reportDayWiseCallsDataChartData
                        )
                          ? 1
                          : undefined,
                        label: "Number of calls",
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
            <div className="col">
              <div className="card">
                <div className="card__header">
                  <h3 className="title">Hourly Calls</h3>
                </div>
                <div className="card__body">
                  <LineChart
                    height={300}
                    colors={["#8b58f1"]}
                    series={[{ data: reportHourlyCallsChartData }]}
                    xAxis={[
                      {
                        scaleType: "point",
                        data: reportHourlyCallsChartLabelData,
                        label: "Time of the Day (Hours)",
                      },
                    ]}
                    yAxis={[
                      {
                        tickMinStep: hasChartDataValue(
                          reportHourlyCallsChartData
                        )
                          ? 1
                          : undefined,
                        label: "Number of calls",
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="cardRow">
            <div className="col">
              <div className="card">
                <div className="card__header">
                  <h3 className="title">Call Duration</h3>
                </div>
                <div className="card__body">
                  <LineChart
                    height={350}
                    grid={true}
                    colors={["#8b58f1", "#B519EC"]}
                    series={[
                      {
                        data: reportCallDurationChartData,
                        area: "true",
                        showMark: false,
                      },
                    ]}
                    xAxis={[
                      {
                        scaleType: "point",
                        data: reportCallDurationChartLabelData,
                        label: "Month",
                      },
                    ]}
                    yAxis={[
                      {
                        label: "Total call duration (minutes)",
                      },
                    ]}
                    slotProps={{
                      legend: {
                        direction: "row",
                        position: { vertical: "top", horizontal: "left" },
                        itemGap: 62,
                      },
                    }}
                    sx={{
                      ".MuiAreaElement-root": {
                        fill: "url(#paint0_linear_45_2)",
                      },
                      ".MuiChartsAxis-label": {
                        transform: "translateX(-18px) !important",
                      },
                      padding: 1,
                    }}
                  >
                    <ChartColorSwitch />
                  </LineChart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
